module.exports = __webpack_public_path__ + "img/youm_sabe3_logo.5b155c3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/media/arabic/youm_sabe3_logo.png
// module id = ./assets/img/media/arabic/youm_sabe3_logo.png
// module chunks = 0 9 11 12